export default () => {
	var playNameRecording = function (event) {
		event.preventDefault();
		var audio_src = this.href;
		var audio_tag = new Audio(audio_src);

		audio_tag.play()
			.then(function (e) {
				/* it worked, do nothing */
				console.log('playing name recording');
			}).catch(function (error) {
			// it didn't work, link to MP3
			console.log(audio_src, error);
			window.location.href = audio_src;
			return false;
		});

		return false;
	};
	var name_recordings = document.querySelectorAll('.name-recording .audioLink');
	name_recordings.forEach(recording => {
		recording.addEventListener('click', playNameRecording);
	});
}
